import React from "react";
import { ModalType, useModal } from "../../../../Context/ModalContext";

function SignatureButton(  ) {
  const { toggleShow } = useModal();

  return (
      <div className="toolbar-button"
           onClick={ () => {toggleShow(true, null, ModalType.signature);} }
           data-test={"layout-signature"}
      >
        <i className="fas fa-signature"></i>
      </div>
      );
      }
      export default SignatureButton;